/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { ICompanyPageOwnProps, ICompanyPageStateProps, ICompanyPageDispatchProps, CompanyPage } from "../../components/company/CompanyPage";
import { ITypedOption } from "../../models/common/typedOption";
import { CompanyThunkDispatch, getCompanyPage } from "source/models/store/company/storeCompanyEffects";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ICompanyPageOwnProps): ICompanyPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            companyPage: null
        };
    }
    const company = applicationState.company;
    return {
        appState: applicationState.session,
        dataId: company.page.dataId,
        companyPage: company.page.companyPage
    };
}

export function mapDispatchToProps(dispatch: CompanyThunkDispatch): ICompanyPageDispatchProps {
    return {
        onGetCompanyPage: () => dispatch(getCompanyPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<ICompanyPageStateProps, ICompanyPageDispatchProps, ICompanyPageOwnProps>(mapStateToProps, mapDispatchToProps)(CompanyPage);